<div>
    <mat-form-field appearance="fill" *ngIf="searchForm" class="hide-errors">
        <mat-label>{{ placeholder }}</mat-label>
        <input
            matInput
            [formControl]="searchForm"
            type="search"
            autocomplete="off"
            #searchInput
        />
        <span
            matPrefix
            class="icon icon__left icon-search"
        ></span>
        <span
            *ngIf="searchForm.value.length > 0"
            matSuffix
            (click)="iconClicked()"
            class="icon icon-close"
        ></span>
    </mat-form-field>
</div>
